import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useContext } from "react";

import type { Api, Me } from "./api";
import { ApiContext } from "./apiContext";

export function useApi(): Api {
  const api = useContext(ApiContext);
  if (!api) throw new Error("ApiProvider の外で useApi を呼んでいる");
  return api;
}

/** 「自分」は画面のあちこちで使うのでキャッシュ1本にまとめる。 */
export function useMe(): UseQueryResult<Me> {
  const api = useApi();
  return useQuery({ queryKey: ["me"], queryFn: api.me, staleTime: 60_000 });
}
